<template lang="html">
  <div class="blog">
    <section class="middle-intro row-start">
      <div class="container">
        <h1 class="title -intro">{{ $t("menu.blog") }}</h1>
        <img src="/static/img/gifs/blog.gif" class="imagen-animacion" alt="blog"/>
      </div>
    </section>
    <div class="container">
      <section class="tool-search">
        <input
          type="text"
          :placeholder="$t('blog.buscar')"
          id="searchTool"
          v-model="textSearch"
          @keyup.enter="search"
        />
        <button @click="search" class="btn-search fa fa-search"></button>
      </section>
    </div>

    <section class="list-entries container">
      <div class="all-entries">
        <blog-el
          v-for="(noticia, key) in noticia"
          :key="key"
          :imageUrl="noticia.header_img.url"
          :title="noticia.title"
          :description="noticia.header"
          :slug="noticia.slug"
          :date="noticia.updated_at"
        ></blog-el>
      </div>
      <button
        class="btn-rounded-blue"
        @click="moreEntries"
        v-if="total != noticia.length"
        tabindex="-1"
      >
        {{ $t("blog.cargarMas") }}
      </button>
    </section>
  </div>
</template>

<script lang="js">
import router from '@/router';
import moment from 'moment'
import blogEl from "@/components/parts/blog-el.vue";
import { mapGetters, mapActions } from "vuex";
export default  {
  name: 'blog',
  props: [],
  mounted() {
    this.setData();
  },
  data() {
    return {
      noticia : [],
      textSearch: "",
      data:[],
      total: null,
      actualPage: 1,
    }
  },
  methods: {

    ...mapActions(["requestNoticia"]),
    setData() {
      let data = {
        // length: (this.actualPage == 1 ) ? 6: 6,
        length: 6,
        page: this.actualPage,
        order: [
          {
            name: "updated_at",
            direction: "desc",
          },

        ],

        filters: [
          {
            name: "title",
            search: this.textSearch,
            textFilter: 1,
          },
           {
            name: "successes",
            search: "0"
          },
        ],
      };

      this.loading = true;

      this.requestNoticia(data).then((r) => {
        this.noticia = this.noticia.concat(r.data);
        this.loading = false;
        this.total = r.recordsFiltered;
      });
    },
      moreEntries() {
        this.actualPage++;
        this.setData();
    },

    search(){
      this.actualPage = 1;
      this.noticia = [];
      this.setData();
    }
  },
   computed: {
    ...mapGetters({
      server: "getServer",
    })
  },
  components: {
     "blog-el": blogEl
  },
  watch: {
    "$route.params.id"() {
        this.setData();
      },
      'textSearch'(){
      if(this.textSearch == ""){
        this.actualPage = 1;
        this.noticia = [];
        this.setData();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/blog.vue